module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/static/favicon.ico
// module id = 17
// module chunks = 0